// types
import type { FreeTextJSONSchema } from "../../../../types";
// hooks
import { useBlockType } from "../../contexts/BlockTypeContext";
// components
import RichTextEditor from "components/rich-text-editor/RichTextEditor";
// context
const PLACEHOLDER = "Enter text";

type Props = {
  jsonSchema: FreeTextJSONSchema;
  onChangeJsonSchema: (arg: FreeTextJSONSchema) => void;
};

const FreeText = ({ jsonSchema, onChangeJsonSchema }: Props) => {
  const { isEdit } = useBlockType();

  return (
    <RichTextEditor
      value={jsonSchema.description}
      placeholder={PLACEHOLDER}
      readOnly={!isEdit}
      onChange={(e) => {
        jsonSchema.description = e || "";
        onChangeJsonSchema(jsonSchema);
      }}
    />
  );
};

export default FreeText;
